export const sortableColumns = {
    createdDate: 'createdDate',
    createdBy: 'createdBy'
};
